import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { useSelector } from 'react-redux'

import { AuthenticationType } from 'authentication/shared/types'
import useYesObject from 'yesObject/shared/hooks/useYesObject'
import Iframe from 'shared/components/Iframe'
import { useIframe } from 'shared/hooks'
import { Node, Task, TaskExecutorProps } from './TaskExecutor.types'

const TaskExecutor = ({
  props: { returnUrl, taskUuid, returnOnFinish }
}: TaskExecutorProps) => {
  const { language } = useTranslation()

  const token = useSelector(
    ({ authentication }: AuthenticationType) => authentication.token
  )

  const { yesObject: task } = useYesObject<Task>({
    objectUUID: taskUuid,
    objectclassUUID: globalThis.taskObjectclassUuid,
    showLoading: true,
    enabled: !!taskUuid
  })

  const process = task?.workflow?.[0]

  const executionState = JSON.parse(
    (process?.execution_state as string) ?? '{}'
  )

  const node = executionState?.nodes?.find(
    (node: Node) => node.uuid === taskUuid
  )

  const tokenUuid = node?.workflow_uuid

  const processEngineUrl = globalThis.waWorkflowengineUrl

  const iframeQueryString = `token=${token}&lang=${language}`

  const iframeUrl = `${processEngineUrl}workflow/${tokenUuid}?${iframeQueryString}`

  const { iframeAttributes, receiveMessage } = useIframe({
    origin: processEngineUrl,
    src: iframeUrl,
    interactionReturnUrl: returnUrl,
    returnOnFinishedInteraction: returnOnFinish
  })

  const onReceivedMessage = useCallback(
    (event: MessageEvent) => {
      receiveMessage(event)
    },
    [receiveMessage]
  )

  useEffect(() => {
    globalThis.addEventListener('message', onReceivedMessage)
    return () => globalThis.removeEventListener('message', onReceivedMessage)
  }, [onReceivedMessage])

  return (
    <>
      {tokenUuid && iframeAttributes ? (
        <Iframe key={iframeAttributes.src} {...iframeAttributes} />
      ) : null}
    </>
  )
}

export default TaskExecutor
